import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import './InvestorPageHeading.scss';

const InvestorPageHeading = ({ heading, anchorId, isNarrow }) => {
    return (
        <div className="investor-page-heading" id={anchorId} >
            <h1 className={cn("investor-page-heading__heading", {
                "investor-page-heading__heading_narrow": isNarrow
            })}>
                {heading}
            </h1>
        </div>
    );
};

InvestorPageHeading.propTypes = {
    heading: PropTypes.string,
    anchorId: PropTypes.string,
    isNarrow: PropTypes.bool
};

export default InvestorPageHeading;


// WEBPACK FOOTER //
// ./src/components/InvestorPageHeading/InvestorPageHeading.jsx